import { FC } from 'react';
import { LandingProductDetailsStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { getProductsByParentReferenceKeys } from 'commerce/scayle/product-management';
import { IAdaptedProduct } from 'commerce/scayle/utils/adapter/types';
import {
  addAverageRatingToProducts,
  getAverageRatingForProducts,
} from 'commerce/services/reviews/utlls';
import { getBrandStories } from 'commerce/storyblok/api';
import { IServerProps } from '../types';
import { ProductInfo } from './ProductInfo';
import { ProductsTabs } from './ProductTabs';
import { IProductInfo } from './types';
import styles from './styles.module.css';

export const LandingProductDetails: FC<{
  blok: LandingProductDetailsStoryblok;
  serverProps: IServerProps;
}> = async ({ blok, serverProps }) => {
  const { productDetails, jumpMarkId } = blok;
  const locale = serverProps.params.locale;

  if (!productDetails?.length) {
    return null;
  }

  const productDetailsIds = productDetails?.map(({ productId }) => productId);

  const { response: products, error } = await getProductsByParentReferenceKeys(
    productDetailsIds || [],
  );

  await Promise.all(
    products?.map(async (p, i) => {
      const brandResp = await getBrandStories(locale, {
        name: p.brand,
        version: 'published',
        excluding_fields: 'body',
      });
      const brand = brandResp.response?.data.stories[0] || undefined;

      const brandLink =
        brand?.translated_slugs?.find((s) => s.lang === locale)?.path ||
        brand?.full_slug ||
        '';

      products[i] = { ...p, brandLink };
    }) || [],
  );

  if (error) {
    console.error(error);
    return;
  }

  const productWithSaleableFlag = products?.map((product) => {
    const relevantItem = productDetails?.find(
      (item) => item.productId === product.referenceKey,
    );

    return {
      ...product,
      productName: relevantItem?.name || product.name,
      isSaleable: relevantItem?.isSaleable,
      productDescription: relevantItem?.productDescription,
    };
  });

  const averageRating = await getAverageRatingForProducts(
    productWithSaleableFlag as IAdaptedProduct[],
  );

  const productList = addAverageRatingToProducts({
    products: productWithSaleableFlag,
    rating: averageRating,
  }) as IProductInfo['product'][];

  return !productList?.length ? null : (
    <Container className={styles.root} id={jumpMarkId}>
      {productList?.length === 1 ? (
        <ProductInfo product={productList[0]} />
      ) : (
        <ProductsTabs products={productList} />
      )}
    </Container>
  );
};
